export function objectToSearchParams(
  obj: Record<string, unknown>
): URLSearchParams {
  const res = new URLSearchParams();

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(obj)) {
    if (Array.isArray(value)) {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of value) {
        res.append(key, item);
      }

      continue;
    }

    res.append(key, `${value}`);
  }

  return res;
}
